 <!-- src\views\pages\crm\contacts\contacts-list.vue -->

<template>
  <layout-header />
  <layout-sidebar />

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb title="Contacts" text="CRM" text1="Contacts list" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <!-- <div class="me-2 mb-2">
            <div
              class="d-flex align-items-center border bg-white rounded p-1 me-2"
            >
              <router-link
                to="/crm/contacts"
                class="btn btn-icon btn-sm active bg-primary text-white me-1"
              >
                <i class="ti ti-list-tree"></i>
              </router-link>
              <router-link to="/crm/contacts-grid" class="btn btn-icon btn-sm">
                <i class="ti ti-layout-grid"></i>
              </router-link>
            </div>
          </div> -->
          <div class="me-2 mb-2">
            <button
              class="btn btn-white d-inline-flex align-items-center"
              @click="exportCsv"
              v-can="'Contact.Export'"
            >
              <i class="ti ti-file-type-csv me-1"></i>Export CSV
            </button>
          </div>
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-primary d-flex align-items-center"
              @click="openAdd"
              v-can="'Contact.Create'"
            >
              <i class="ti ti-circle-plus me-2"></i>Add New Contact
            </a>
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Contact List -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Contact List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3 dq-list-toolbar"
          >
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input
                  type="text"
                  class="form-control date-range bookingrange"
                  ref="dateRangeInput"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy"
                />
                <span class="input-icon-addon"
                  ><i class="ti ti-chevron-down"></i
                ></span>
              </div>
            </div>
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Select Status
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="reload({ status: '' })"
                    >All</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="reload({ status: 'Active' })"
                    >Active</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="reload({ status: 'Inactive' })"
                    >Inactive</a
                  >
                </li>
              </ul>
            </div>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : Last 7 Days
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Recently Added</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Ascending</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Descending</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <ContactsTable @edit="openEdit" @delete="openDelete" />
          </div>
        </div>
      </div>
      <!-- /Contact List -->
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>

  <contacts-modal :editItem="editItem" @saved="reload()" />
</template>

<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref, onMounted,nextTick } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import Modal from "bootstrap/js/dist/modal";
import { useRoute } from 'vue-router';

import { useContactStore } from "@/stores/contactStore";
import { useUserStore } from "@/stores/userStore";
import { useDealStore } from "@/stores/dealStore";

import ContactsTable from "./contacts-table.vue";
import ContactsModal from "@/components/modal/contacts-modal.vue";


const route = useRoute();

const contactStore = useContactStore();
const userStore = useUserStore();
const dealStore = useDealStore();

const dateRangeInput = ref(null);
const editItem = ref(null);

function openAdd() {
  editItem.value = null;
  nextTick(() => {
    const el = document.getElementById("add_contact");
    Modal.getOrCreateInstance(el)?.show();
  });
}
function openEdit(row) {
  editItem.value = row;
  nextTick(() => {
    const el = document.getElementById("add_contact");
    Modal.getOrCreateInstance(el)?.show();
  });
}

function openDelete(row) {
  editItem.value = row;
  nextTick(() => {
    const el = document.getElementById("delete_contact");
    Modal.getOrCreateInstance(el)?.show();
  });
}

function reload(extra = {}) {
  contactStore.fetchAll({ ...extra, force: true });
}

function exportCsv() {
  const rows = Array.isArray(contactStore.items) ? contactStore.items : [];
  const header = [
    "Name",
    "Account",
    "Email",
    "Phone",
    "Job Title",
    "Owner",
    "Status",
    "Created At",
  ];
  const body = rows.map((contact) => [
    contact.name || "",
    contact.client?.name || contact.company_name || "",
    contact.email || "",
    contact.phone || "",
    contact.job_title || "",
    [contact.owner?.first_name, contact.owner?.last_name].filter(Boolean).join(" ") ||
      contact.owner?.email ||
      "",
    contact.status || "",
    contact.created_at || "",
  ]);

  const csv = [header, ...body]
    .map((row) =>
      row.map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(",")
    )
    .join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `crm-contacts-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

onMounted(async () => {
  if (!userStore.users?.length) await userStore.ensureUsers({ per_page: 200 });
  if (!dealStore.items?.length) await dealStore.ensureList({ per_page: 200 });
  await contactStore.ensureList();

  if (dateRangeInput.value) {
    const start = moment().subtract(6, "days");
    const end = moment();
    new DateRangePicker(
      dateRangeInput.value,
      {
        startDate: start,
        endDate: end,
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      },
      () => {}
    );
  }
});
</script>

<style scoped>
@media (max-width: 767.98px) {
  .dq-list-toolbar {
    align-items: stretch !important;
  }

  .dq-list-toolbar > * {
    width: 100%;
    margin-right: 0 !important;
  }

  .dq-list-toolbar .dropdown,
  .dq-list-toolbar .dropdown-toggle,
  .dq-list-toolbar .form-control,
  .dq-list-toolbar .input-icon-end {
    width: 100%;
  }

  .custom-datatable-filter.table-responsive {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: calc(100% + 2rem);
  }
}
</style>


